import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Link,
  TextField,
  makeStyles,
  Grid,
} from "@material-ui/core";
import Page from "src/components/Page";
import { useForm } from "react-hook-form";
import { useNavigate, NavLink as RouterLink } from "react-router-dom";
import {
  apiEndpoints,
  apiPostRequest,
  apiGetRequest,
  apiPutRequest,
} from "src/utils/api/api";
import { buildAuthPayload, buildPassChangePayload } from "src/utils/utils";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { useCookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { kmMessages } from "src/constant/Messages";
import renderHTML from "react-render-html";
import { useParams } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
  },
  kmmessage: {
    marginTop: theme.spacing(2),
  },
  passrecovery: {
    marginLeft: theme.spacing(1),
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const LoginView = ({
  inactivityLogout,
  systemInfo,
  redirectPath,
  setAuthorized,
  setCurrentUserData,
  enableGlobalLoader,
  disableGlobalLoader,
  setInactivityLogout,
  unsetRedirectPath,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const [username, setUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [infoTitleMessage, setInfoTitleMessage] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [warningTitleMessage, setWarningTitleMessage] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [passwordChange, setPasswordChange] = useState(false);
  const [kmEmail, setKmEmail] = useState(null);
  const [redirectPathLocal, setRedirectPathLocal] = useState(null);
  const { passwordChangeKey } = useParams();

  const {
    handleSubmit,
    register,
    errors,
    formState: { isSubmitting },
  } = useForm();

  const resetMessages = () => {
    setInfoMessage("");
    setInfoTitleMessage("");
    setErrorMessage("");
    setWarningMessage("");
    setWarningTitleMessage("");
  };

  useEffect(() => {
    if (redirectPath) {
      setRedirectPathLocal(redirectPath);
      unsetRedirectPath();
    }
    resetMessages();
    if (inactivityLogout) {
      setWarningTitleMessage("Wylogowanie automatyczne");
      setWarningMessage("Zostałeś wylogowany z systemu z powodu bezczynności.");
    }
    if (passwordChangeKey) {
      resetMessages();
      setPasswordChange(true);
    }
  }, [inactivityLogout]);

  const userLogin = (usernameVal, passwordVal) => {
    resetMessages();
    apiPostRequest(
      apiEndpoints.login.path,
      buildAuthPayload(usernameVal, passwordVal),
      true
    )
      .then((data) => {
        setInactivityLogout(false);

        if (data.passwordChange) {
          disableGlobalLoader();
          resetMessages();
          setPasswordChange(data.passwordChange);
        } else {
          apiGetRequest(apiEndpoints.getLoggedUser.path, true)
            .then((data) => {
              disableGlobalLoader();
              setAuthorized(true);
              setCurrentUserData(data);
              if (redirectPathLocal) {
                navigate(redirectPathLocal);
              } else {
                navigate("/");
              }
            })
            .catch((error) => {
              disableGlobalLoader();
              if (error.response) {
                if (error.response.status === 403) {
                  if (error.response.data) {
                    if (error.response.data.code === "LICENCE_NOT_ACCEPTED") {
                      navigate("/licencja");
                    } else if (
                      error.response.data.code === "POLICY_NOT_ACCEPTED"
                    ) {
                      navigate("/politykabezp");
                    } else if (
                      error.response.data.code === "MEMBER_TASKS_NOT_ACCEPTED"
                    ) {
                      navigate("/deklaracjazadaniacz");
                    } else if (
                      error.response.data.code === "OBSERVER_TASKS_NOT_ACCEPTED"
                    ) {
                      navigate("/deklaracjazadaniaobs");
                    }
                  }
                }
              }
              setErrorMessage(kmMessages.error.login.unexgetprofile);
            });
        }
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response) {
          if (error.response.status === 401) {
            if (error.response.data) {
              if (error.response.data.code === "ERROR_UNAUTHORIZED") {
                error.response.data.description
                  ? setErrorMessage(
                      kmMessages.error.login.invaliduserpass.replaceAll(
                        "{count}",
                        error.response.data.description
                      )
                    )
                  : setErrorMessage(kmMessages.error.login.badloginpass);
              } else if (
                error.response.data.code ===
                "ERROR_UNAUTHORIZED_LOGIN_TRIES_EXC"
              ) {
                let msgParams = error.response.data.description.split(",");
                setErrorMessage(
                  kmMessages.error.login.triescountexc
                    .replaceAll("{count}", msgParams[0])
                    .replaceAll("{timeout}", msgParams[1])
                );
              } else if (error.response.data.code === "ERROR_USER_BLOCKED") {
                setErrorMessage(kmMessages.error.password_reset.usernotactive);
              } else {
                setErrorMessage(kmMessages.error.login.badloginpass);
              }
            } else {
              setErrorMessage(kmMessages.error.login.badloginpass);
            }
          } else {
            setErrorMessage(kmMessages.error.global.apierror);
          }
        } else {
          setErrorMessage(kmMessages.error.global.apierrornoresp);
        }
      });
  };

  const onSubmit = (values) => {
    enableGlobalLoader();

    // removeCookie("JwtToken");

    userLogin(values.username, values.password);
  };

  const onSubmitPasswordChange = (values) => {
    enableGlobalLoader();
    resetMessages();

    // removeCookie("JwtToken");

    apiPutRequest(
      apiEndpoints.passwordChange.path,
      buildPassChangePayload(
        passwordChangeKey ? values.username : username,
        passwordChangeKey ? null : values.cpassword,
        passwordChangeKey ? passwordChangeKey : null,
        values.npassword1,
        values.npassword2
      ),
      true
    )
      .then((data) => {
        userLogin(passwordChangeKey ? values.username : username, values.npassword1);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response) {
          if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "ERROR_PASSWORDS_NOT_MATCH") {
              setErrorMessage(kmMessages.error.password_reset.passnotmatch);
            } else if (
              error.response.data.code === "ERROR_INVALID_CURRENT_PASSWORD"
            ) {
              setErrorMessage(kmMessages.error.password_reset.passwrong);
            } else if (
              error.response.data.code === "ERROR_PASSWORD_NOT_STRENGTH_ENOUGH"
            ) {
              setErrorMessage(kmMessages.error.password_reset.passstrength);
            } else if (
              error.response.data.code === "ERROR_PASSWORD_USED_IN_PAST"
            ) {
              setErrorMessage(
                kmMessages.error.password_reset.passuniqinpast.replaceAll(
                  "{count}",
                  error.response.data.description
                )
              );
            } else {
              setErrorMessage(kmMessages.error.password_reset.unexpasschange);
            }
          } else {
            setErrorMessage(kmMessages.error.password_reset.unexpasschange);
          }
        } else {
          setErrorMessage(kmMessages.error.password_reset.apierrornoresp);
        }
      });
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordReset = (e) => {
    e.preventDefault();
    enableGlobalLoader();
    resetMessages();
    if (username.length == 0) {
      setErrorMessage(kmMessages.error.password_reset.username);
      disableGlobalLoader();
    } else {
      setErrorMessage("");
      apiPostRequest(
        apiEndpoints.passwordReset.path,
        { username: username },
        false
      )
        .then((data) => {
          disableGlobalLoader();
          setInfoTitleMessage(kmMessages.info.password_reset.mailsenttitle);
          let messageBody = kmMessages.info.password_reset.mailsentbody;
          setInfoMessage(messageBody.replaceAll("%s", data.email));
        })
        .catch((error) => {
          disableGlobalLoader();
          if (
            error.response &&
            error.response.status === 400 &&
            error.response.data
          ) {
            if (error.response.data.code === "ERROR_USER_NOT_EXISTS") {
              setErrorMessage(kmMessages.error.password_reset.usernotex);
            } else if (error.response.data.code === "ERROR_USER_NOT_ACTIVE") {
              setErrorMessage(kmMessages.error.password_reset.usernotactive);
            } else {
              setErrorMessage(kmMessages.error.global.apierror);
            }
          } else {
            setErrorMessage(kmMessages.error.global.apierror);
          }
        });
    }
  };

  return (
    <Page className={classes.root} title="Strona logowania">
      <Box height="100%" display="flex" flexDirection="column">
        <Box
          display="flex"
          flexWrap="wrap"
          alignContent="center"
          p={1}
          css={{ height: "8vh" }}
        ></Box>
        <Container maxWidth="sm">
          {!passwordChange ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box mb={1}>
                <Typography color="textPrimary" variant="h2">
                  Logowanie
                </Typography>
                {errorMessage?.length > 0 ? (
                  <Alert severity="error" className={classes.kmmessage}>
                    {errorMessage}
                  </Alert>
                ) : (
                  <></>
                )}
                {infoMessage ? (
                  <Alert severity="success" className={classes.kmmessage}>
                    <AlertTitle>
                      <strong>{infoTitleMessage}</strong>
                    </AlertTitle>
                    <div>{renderHTML(infoMessage)}</div>
                  </Alert>
                ) : (
                  <></>
                )}
                {warningMessage ? (
                  <Alert severity="warning" className={classes.kmmessage}>
                    <AlertTitle>
                      <strong>{warningTitleMessage}</strong>
                    </AlertTitle>
                    <div>{renderHTML(warningMessage)}</div>
                  </Alert>
                ) : (
                  <></>
                )}
              </Box>
              <TextField
                error={errors.username ? true : false}
                id="username"
                fullWidth
                helperText={
                  errors.username &&
                  errors.username.type === "required" &&
                  "Podaj nazwę użytkownika"
                }
                label="Login"
                margin="normal"
                name="username"
                onChange={handleUsernameChange}
                type="text"
                variant="filled"
                inputRef={register({ required: true })}
              />
              <TextField
                error={errors.password ? true : false}
                fullWidth
                id="password"
                helperText={
                  errors.password &&
                  errors.password.type === "required" &&
                  "Podaj hasło"
                }
                label="Hasło"
                margin="normal"
                name="password"
                type="password"
                variant="filled"
                inputRef={register({ required: true })}
              />
              <Box my={2}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Zaloguj
                </Button>
              </Box>
            </form>
          ) : (
            <form onSubmit={handleSubmit(onSubmitPasswordChange)}>
              <Box mb={1}>
                <Typography color="textPrimary" variant="h2">
                  Zmiana hasła użytkownika <strong>{username}</strong>
                </Typography>
                {errorMessage?.length > 0 ? (
                  <Alert severity="error" className={classes.kmmessage}>
                    {errorMessage}
                  </Alert>
                ) : (
                  <></>
                )}
                {infoMessage ? (
                  <Alert severity="success" className={classes.kmmessage}>
                    <AlertTitle>
                      <strong>{infoTitleMessage}</strong>
                    </AlertTitle>
                    <div>{renderHTML(infoMessage)}</div>
                  </Alert>
                ) : (
                  <></>
                )}
              </Box>
              <Typography></Typography>
              {passwordChangeKey ? (
                <TextField
                  error={errors.username ? true : false}
                  fullWidth
                  id="username"
                  helperText={
                    errors.username &&
                    errors.username.type === "required" &&
                    "Pole wymagane"
                  }
                  label="Login"
                  margin="normal"
                  name="username"
                  type="text"
                  variant="filled"
                  inputRef={register({ required: true })}
                />
              ) : (
                <TextField
                  error={errors.cpassword ? true : false}
                  fullWidth
                  id="cpassword"
                  helperText={
                    errors.cpassword &&
                    errors.cpassword.type === "required" &&
                    "Pole wymagane"
                  }
                  label="Obecne hasło"
                  margin="normal"
                  name="cpassword"
                  type="password"
                  variant="filled"
                  inputRef={register({ required: true })}
                />
              )}
              <TextField
                error={errors.npassword1 ? true : false}
                fullWidth
                id="npassword1"
                helperText={
                  errors.npassword1 &&
                  errors.npassword1.type === "required" &&
                  "Pole wymagane"
                }
                label="Nowe hasło"
                margin="normal"
                name="npassword1"
                type="password"
                variant="filled"
                inputRef={register({ required: true })}
              />
              <TextField
                error={errors.npassword2 ? true : false}
                fullWidth
                id="npassword2"
                helperText={
                  errors.npassword2 &&
                  errors.npassword2.type === "required" &&
                  "Pole wymagane"
                }
                label="Powtórz nowe hasło"
                margin="normal"
                name="npassword2"
                type="password"
                variant="filled"
                inputRef={register({ required: true })}
              />
              <Box my={2}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Zapisz hasło
                </Button>
              </Box>
            </form>
          )}

          {!passwordChange ? (
            <Box display="flex" pb={1}>
              <Typography color="textSecondary" component="h2" variant="body1">
                Nie pamiętasz hasła?
              </Typography>
              <Link
                onClick={handlePasswordReset}
                component="button"
                variant="h6"
                className={classes.passrecovery}
              >
                <b>Odzyskaj dostęp</b>
              </Link>
            </Box>
          ) : (
            <></>
          )}
          <Typography
            color="textSecondary"
            variant="subtitle2"
            component="h3"
            paragraph
          >
            W przypadku problemów z zalogowaniem się do systemu należy
            skontaktować z administratorem systemu pod adresem
            {systemInfo.kmEmail ? (
              <>
                {" "}
                <Link href={`mailto:${systemInfo.kmEmail}`} variant="body2">
                  {systemInfo.kmEmail}
                </Link>
              </>
            ) : (
              "."
            )}
          </Typography>
          <Box display="flex" mb={1}>
            <Typography color="textSecondary" component="h3" variant="body1">
              Zachęcamy do zapoznania się z
              <Link
                component={RouterLink}
                variant="h6"
                to={`/deklaracjadostepnosc`}
                className={classes.passrecovery}
              >
                Deklaracją Dostępności
              </Link>
            </Typography>
          </Box>
        </Container>
        <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
          <Box display="flex" flexDirection="column">
            <img
              className={classes.img}
              alt="Logo UE stopka"
              src="/static/images/logo_ue_main.jpg"
            />
            <Typography
              variant="caption"
              gutterBottom
              color="textSecondary"
              align="center"
              component="p"
            >
              Aplikacja współfinansowana przez Unię Europejską ze środków
              Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
              Operacyjnego Województwa Podlaskiego na lata 2014-2020
            </Typography>
            <Typography
              color="textPrimary"
              variant="subtitle2"
              align="center"
              component="p"
            >
              2021 © Urząd Marszałkowski Województwa Podlaskiego
            </Typography>
          </Box>
        </Box>
      </Box>
      {/* </Box> */}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  inactivityLogout: state.globalData.inactivityLogout,
  systemInfo: state.globalData.systemInfo,
  redirectPath: state.globalData.redirectPath,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setCurrentUserData: (currentUserData) =>
    dispatch(actions.setCurrentUser(currentUserData)),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setInactivityLogout: (inactivityLogout) =>
    dispatch(actions.setInactivityLogout(inactivityLogout)),
  unsetRedirectPath: () => dispatch(actions.unsetRedirectPath()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
